export var isOptionGroup = function (value) {
    return typeof value === 'object' && value.hasOwnProperty('options') && Array.isArray(value.options);
};
//# sourceMappingURL=utils.js.map